var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_243",
    "data-name": "Group 243",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.233,
    height: 92.233,
    viewBox: "0 0 92.233 92.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 92.233,
    height: 92.233,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M0,0V92.233H92.233V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243-2",
    "data-name": "Group 243",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M47.228,0H0V92.233H92.233V0ZM45,90.01H2.224V47.228H45Zm0-45H2.224V2.224H45ZM83.162,65.4a.858.858,0,0,1-.858.858H79.162a.858.858,0,0,0-.606,1.465c1.692,1.7,2.394,2.425,3.046,3.207a.857.857,0,0,1-.147,1.23l-1.3.977a.858.858,0,0,1-1.2-.173c-.21-.284-.44-.585-.722-.933a.866.866,0,0,0-.761-.319c-1.409.15-3.313.278-4.845.369a.854.854,0,0,0-.8.854V73.9a.857.857,0,0,0,.858.857h8.257a.858.858,0,0,1,.858.857v1.02a.858.858,0,0,1-.858.858H72.68a.858.858,0,0,0-.858.857v1.454a.857.857,0,0,0,.858.857H82.3a.858.858,0,0,1,.858.858v1.12a.858.858,0,0,1-.858.858H58.938a.858.858,0,0,1-.858-.858v-1.12a.858.858,0,0,1,.858-.858h8.59a.857.857,0,0,0,.858-.857V78.354a.857.857,0,0,0-.858-.857H60.406a.858.858,0,0,1-.858-.858v-1.02a.858.858,0,0,1,.858-.857h7.123a.857.857,0,0,0,.858-.857v-.747a.869.869,0,0,0-.9-.865c-4.74.172-6.46.236-7.338.27a.856.856,0,0,1-.88-.73l-.206-1.387a.857.857,0,0,1,.852-.984c.387,0,.81.006,1.144.013a.863.863,0,0,0,.756-.422c.424-.71.669-1.137.879-1.568a.857.857,0,0,0-.774-1.226h-2.98a.858.858,0,0,0-.858.858v.743c0,7.639-.78,11.288-3.041,15.308a.862.862,0,0,1-1.309.235l-1.625-1.385a.862.862,0,0,1-.2-1.062c2.6-4.925,2.6-8.23,2.6-13.2V54.94a.858.858,0,0,1,.858-.858H82.3a.858.858,0,0,1,.858.858v5.689a.858.858,0,0,1-.858.858H58.938a.858.858,0,0,0-.858.857v.22a.858.858,0,0,0,.858.858H82.3a.857.857,0,0,1,.858.857ZM90.01,45H47.228V2.224H90.01Z",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M17.331,43.8l1.917.77a.939.939,0,0,0,1.188-.442c1.168-2.273,3.495-7.294,5.363-17.217a.946.946,0,0,1,.918-.773l3.393-.027c2.968-.033,3.935,1.568,3.935,5a37,37,0,0,1-.967,7.972c-.6,2.035-1.634,2.6-3.769,2.6a20.6,20.6,0,0,1-3.349-.28.938.938,0,0,0-1.086.982l.089,1.581a.939.939,0,0,0,.827.882,38.342,38.342,0,0,0,4.254.305c1.1,0,4.436,0,5.937-3.335,1.534-3.4,1.734-8.605,1.734-9.906,0-3.3-.434-9.305-7.138-9.305H27.621a.941.941,0,0,1-.932-1.07c.243-1.782.384-2.892.489-3.863a.94.94,0,0,0-.872-1.037L24.337,16.5a.94.94,0,0,0-1,.863c-.107,1.318-.242,2.72-.455,4.415a.944.944,0,0,1-.934.828h-3.9a.941.941,0,0,0-.941.941v1.741a.941.941,0,0,0,.953.941l3-.039a.94.94,0,0,1,.937,1.117c-.682,3.51-2.131,9.865-5.141,15.155a.945.945,0,0,0,.48,1.336",
    transform: "translate(-7.43 -7.329)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M59.334,35.219a.94.94,0,0,0,1.076.819l2.035-.313a.946.946,0,0,0,.791-1.051c-.992-8.094-3.129-10.42-4.842-12.1a.938.938,0,0,0-1.158-.125l-1.3.814a.937.937,0,0,0-.213,1.409c1.209,1.4,2.818,3.775,3.608,10.549",
    transform: "translate(-24.646 -9.904)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M109.117,36.2c4.626-.329,5.89-11.549,7.694-12.823,2.544-1.8,5.209.835,5.209,8.005,0,9.6-7.263,10.325-14.49,10.458a.827.827,0,0,0-.793.987l.375,1.888a.832.832,0,0,0,.826.669c13.435-.217,17.885-4.888,17.885-14.235,0-7.771-4.332-12.32-8.739-11.573-3.344.568-5.218,6.5-6.9,10.938-.211.554-1.334,2.679-2.271,1.242-.909-1.394.774-10.422,1.578-13.944a.824.824,0,0,0-.75-1.006l-2.162-.149a.83.83,0,0,0-.873.665,77.3,77.3,0,0,0-1.257,14.86c.172,3.314,2.7,4.157,4.673,4.017",
    transform: "translate(-46.375 -7.398)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M127.186,120.031a.454.454,0,0,0-.235-.843h-6.682a.877.877,0,0,0-.747.423c-.411.678-.679,1.122-.894,1.469a.859.859,0,0,0,.733,1.309c2.864,0,5.015-.021,7.232-.14a.854.854,0,0,0,.527-1.49.453.453,0,0,1,.067-.728",
    transform: "translate(-52.626 -52.932)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M105.339,104.124H125.3a.858.858,0,0,0,.858-.858v-.619a.857.857,0,0,0-.858-.858h-19.96a.858.858,0,0,0-.858.858v.619a.858.858,0,0,0,.858.858",
    transform: "translate(-46.4 -45.205)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M15.731,102.977c6.231-.508,23.861-1.81,24.073-.356.235,1.611-3.764.7-11.756,3.969a10.451,10.451,0,0,0-6.893,9.693,9.086,9.086,0,0,0,4.969,7.8c2.923,1.509,6.342,2.339,13,2.428a.88.88,0,0,0,.881-.762l.293-2.18a.876.876,0,0,0-.878-1c-9,.143-14.427-1.706-14.427-6.594,0-4.5,3.827-6.233,5.932-6.959a54.463,54.463,0,0,1,8.675-2.169c5.323-.932,5.294-3.525,5.327-4.1,0,0,.437-2.468-2.661-3.5-4.386-1.462-20.907-.568-26.749-.074a.875.875,0,0,0-.8.906l.072,2.049a.875.875,0,0,0,.945.846",
    transform: "translate(-6.534 -43.722)",
    fill: "#f36a10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo-square.21ed5a483620fb2bf221395b1629eb43.svg";
export { ForwardRef as ReactComponent };